﻿'use strict';

function bindTrackingOnClick(elem, name) {
	if (elem) {
		elem.addEventListener('click', function (e) {
			if (window.utag && window.utag.link) {
				utag.link({
					'link_name': utag.data.page_name + ' : ' + name,
					'action': utag.data.page_name + ' : ' + name
				});
			}
		});
	}
}

bindTrackingOnClick(document.getElementById('Terms'), 'terms');
bindTrackingOnClick(document.getElementById('MarketingEmails'), 'marketingEmails');
bindTrackingOnClick(document.getElementById('cta'), 'continue');